
const Flex = ({
  children,
  direction = "row",
  wrap = "nowrap",
  justify = "flex-start",
  align = "center",
  items = "stretch",
  gap = "0",
  className = "",
}) => {
  const flexClasses = [
    "flex",
    `flex-${direction}`,
    `flex-${wrap}`,
    `justify-${justify}`,
    `align-${align}`,
    items?`items-${items}`:'',
    gap && `gap-${gap}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={flexClasses}>{children}</div>;
};

const FlexItem = ({
  children,
  flex = "none",
  alignSelf = "auto",
  order = "0",
  className = "",
}) => {
  const itemClasses = [
    flex !== "none" && `flex-${flex}`,
    alignSelf !== "auto" && `self-${alignSelf}`,
    order !== "0" && `order-${order}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={itemClasses}>{children}</div>;
};

export { Flex, FlexItem };